import { h, Component } from 'preact';
import style from './style.scss';
import DropList from '../../components/dropList';
const PagesizeDataArray = [10, 25, 50, 100];
export default class PaginationPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageSize: 10,
        }
    }




    handleListClick = (data) => {
        this.setState({ pageSize: data },()=>{
            this.props.paginationProps.changeSizePerPage(this.state.pageSize)
        });
    }

    render({ paginationProps }, { pageSize, modalState }) {

        return (
            <div className={style.paginationPanel}>
                <div className={style.changeSizeOuterWrapper}>
                    <div class={style.changeSizeWrapper}>
                        <span>Rows per page</span>
                            <DropList dataArray={PagesizeDataArray}
                            handleListClick={this.handleListClick}
                            defaultValue={this.state.pageSize}
                            />

                    </div>
                </div>

                <div  className={style.totalText} >
                  <span style="margin-right: 10px;">|</span>

                  {paginationProps.components.totalText}
                </div>

                <div className={style.pagainationWrapper}>
                    <div className={style.pagination}>
                        {paginationProps.components.pageList}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/paginationPanel/index.js